import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import QUERY from 'query-string'

const omit = (object, keys) => (keys || []).forEach(key => delete object[key])

const store = {}

const getSponsorId = (value) => {
  let userInfo = {}
  try { userInfo = JSON.parse(value || sessionStorage.getItem('userInfo') || '{}') || {} }
  catch (_) { }
  return userInfo.sponsorId
}

// patch 当前窗口触发 storage 事件
const setItem = window.sessionStorage.setItem.bind(window.sessionStorage)
window.sessionStorage.setItem = (key, value) => {
  const event = new Event('storage')
  event.storageArea = window.sessionStorage
  event.key = key
  event.newValue = value
  setItem(key, value)
  window.dispatchEvent(event)
}

window.addEventListener('storage', (event) => {
  const { storageArea, key, newValue } = event
  if (storageArea === window.sessionStorage && key === 'userInfo') {
    store.sponsorId = getSponsorId(newValue)
  }
})

store.sponsorId = getSponsorId()

const URL = {
  parse: (url) => {
    url = url || ''
    const searchStart = url.indexOf('?')
    return {
      search: url.slice(searchStart),
      pathname: url.slice(url.indexOf('/'), searchStart)
    }
  }
}

class Link extends PureComponent {
  handleClick = (event) => {
    if (event.ctrlKey || this.props.target === '_blank') return
    const { onClick, replace, history } = this.props
    event.preventDefault()
    if (onClick) onClick()
    const { href } = event.currentTarget
    if (!href) return
    const { pathname, search } = URL.parse(href.slice(href.indexOf('#') + 1))
    let { sponsorId, state, ...query } = QUERY.parse(search)
    try { state = JSON.parse(state) } catch (_) {}
    history[replace ? 'replace' : 'push']({
      pathname,
      search: QUERY.stringify(query),
      state,
    })
  }

  render = () => {
    const { path, query, children, ...props } = this.props
    const search = QUERY.stringify({ ...store, ...query })
    const href = search ? `${path}?${search}` : path

    omit(props, ['dispatch', 'replace'])
    omit(props, ['staticContext', 'history', 'location', 'match']) // withRouter

    return <a {...props} href={'#' + href} onClick={this.handleClick}>{children}</a>
  } 
}

export default withRouter(Link)
